const getItem = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

const setItem = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Do nothing
  }
};

const removeItem = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // Do nothing
  }
};

const clear = () => {
  try {
    localStorage.clear();
  } catch (e) {
    // Do nothing
  }
};

export { setItem, getItem, removeItem, clear };



// WEBPACK FOOTER //
// ./src/services/localStorage.ts